import { atom } from "recoil";

// export type PushSettingType = {
//   effect: string;
//   volume: number;
//   pushOrder: boolean;
//   pushCheckOrder: boolean;
//   pushAssign: boolean;
//   pushPickup: boolean;
//   pushDelivery: boolean;
//   isOrder: boolean;
//   orderCount: number;
// };
export type PushSettingType = {
  effect: string;
  volume: number;
  // autoPushOrder: boolean;
  orderCount: number;
  infinite: boolean;
  delay: number;
};

export const soundList: Record<string, string[]> = {
  // 푸쉬 효과음
  effectSound: [
    `${process.env.PUBLIC_URL}/knockknock/audio/bell_001.mp3`,
    `${process.env.PUBLIC_URL}/knockknock/audio/bell_002.mp3`,
    `${process.env.PUBLIC_URL}/knockknock/audio/bell_004.mp3`,
    `${process.env.PUBLIC_URL}/knockknock/audio/bell_008.mp3`,
    // `${process.env.PUBLIC_URL}/knockknock/audio/bell_005.mp3`,
  ],
};

export const pushSettingState = atom<PushSettingType>({
  key: "pushSetting",
  default: {
    effect: soundList.effectSound[2],
    volume: 10,
    // autoPushOrder: false,
    orderCount: 1000,
    infinite: true,
    delay: 3,
  },
});

Object.freeze(soundList);
